import { RootStore } from './root.store';
import { makeAutoObservable } from 'mobx';
import { IReviewInformation } from '../domains/review.domain';
import { DefaultPrivacyPolicyUrl } from '../domains/tenant-config';

export class ReviewStore {
  root: RootStore;

  private _information: IReviewInformation = {
    isTermAccepted: {
      value: false,
      errorType: 'required',
    },
    isAiTermAccepted: {
      value: false,
      errorType: 'required',
    },
    isCoterminousTermAccepted: {
      value: false,
      errorType: 'required',
    },
  };
  private _aiTermsUrl: string | undefined = undefined;
  private _privacyPolicyUrl: string | undefined = undefined;
  private _showAiTerms: boolean = false;
  private _showTerms: boolean = false;
  private _showCoterminousTerms: boolean = false;

  constructor(root: RootStore) {
    makeAutoObservable(this);
    this.root = root;
  }

  init() {
    const { privacyPolicyUrl, termsAndConditions } = this.root.tenantStore.config;
    const { quoteInfo, hasAiItems, isAiOrder } = this.root.quoteStore;
    this._aiTermsUrl = quoteInfo?.aiTermsUrl;
    this._privacyPolicyUrl = privacyPolicyUrl ?? DefaultPrivacyPolicyUrl;
    this._showAiTerms = !!this._aiTermsUrl && hasAiItems;
    this._information.isAiTermAccepted.errorType = this._showAiTerms ? 'required' : undefined;
    this._showTerms = !!termsAndConditions && !isAiOrder;
    this._information.isTermAccepted.errorType = this._showTerms ? 'required' : undefined;
    this._showCoterminousTerms = !!quoteInfo?.coterminousContractEndDate;
    this._information.isCoterminousTermAccepted.errorType = this._showCoterminousTerms ? 'required' : undefined;
  }

  get information(): IReviewInformation {
    return this._information;
  }

  get aiTermsUrl() {
    return this._aiTermsUrl;
  }

  get privacyPolicyUrl() {
    return this._privacyPolicyUrl;
  }

  get showAiTerms() {
    return this._showAiTerms;
  }

  get showTerms() {
    return this._showTerms;
  }

  get showCoterminousTerms() {
    return this._showCoterminousTerms;
  }

  updateInformation(field: keyof IReviewInformation) {
    const value = !this._information[field].value;
    this._information[field] = {
      value: value,
      errorType: !value ? 'required' : undefined,
    };
  }

  get isFormValid(): boolean {
    return (
      !this._information.isTermAccepted.errorType &&
      !this._information.isAiTermAccepted.errorType &&
      !this._information.isCoterminousTermAccepted.errorType
    );
  }
}
